module.exports = __webpack_public_path__ + "static/media/IMG-20181016-WA0105.15701ab6.jpg";